
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Projet from '@/extend/classes/Projet';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeProjet' })

export default class storeProjet extends VuexModule {
  // States
  private reccords: Projet[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get projetLoading (): boolean {
    return this.dataLoading;
  }
  private get projetRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get projetLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewProjet() {
    return (): Projet => { 
      return this.getProjet(0, true);
    }
  }

  
  public get getProjet () {
    return (id: number, canCreate = false): Projet => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Projet can't be 0")
        return new Projet();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Projet();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Projet.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromProjet(data.reccords[0] as Projet);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listProjet (): Projet[] {
    return this.reccords;
  }

  public get listConfigProjet (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mProjetRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mProjetClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mProjetLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mProjetLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Projet.fromJson(reccord as Projet));
    })
    Projet.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mProjetConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mProjetCreated (obj: Projet): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareProjet(obj)) {
          api.fromProjet(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareProjet(obj)) {
            api.fromProjet(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mProjetUpdated (obj: Projet): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareProjet(obj)) {
          api.fromProjet(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mProjetDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerProjet (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.projetRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerProjet(this.projetCreated, this.projetUpdated, this.projetDeleted);
          this.mProjetRegistered();
        } else {
          setTimeout(() => resolve(this.registerProjet(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.projetLoading && !this.projetLoaded) {
          this.mProjetLoading(true);
          return Projet.list(filter)
            .then((data: ListData) => {
              this.mProjetLoaded(data);
              this.mProjetLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredProjet (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.projetLoading) {
        this.mProjetLoading(true);
        return Projet.list(filter)
          .then((data: ListData) => {
            this.mProjetLoaded(data);
            this.mProjetLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createProjet (obj: Projet): Promise<Projet> {
    return new Promise((resolve, reject) => {
      return Projet.fromJson(obj).createForStoreProjet()
        .then((reccords) => {
          this.mProjetCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateProjet (obj: Projet): Promise<Projet> {
    return new Promise((resolve, reject) => {
      return Projet.fromJson(obj).updateForStoreProjet()
        .then((reccords) => {
          this.mProjetUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteProjet (obj: Projet): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Projet.fromJson(obj).deleteForStoreProjet()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mProjetDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private projetCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mProjetConfigUpdated(config)
    const obj = objConfig.obj as Projet;
    this.mProjetCreated(Projet.fromJson(obj));
  }

  @Action
  private projetUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mProjetConfigUpdated(config)
    const obj = objConfig.obj as Projet;
    this.mProjetUpdated(Projet.fromJson(obj));
  }

  @Action
  private projetDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Projet;
    this.mProjetDeleted(obj.id);
  }
}
